<div class="panel-header-container" [formGroup]="laborCostsFormGroup">
        <div class="panel-header-row">

            <button mat-icon-button (click)="isLaborCostsExpanded = !isLaborCostsExpanded" class="button-expand-collapse">
                <mat-icon class="icon-expand-collapse">
                    {{isLaborCostsExpanded ? 'expand_more' : 'chevron_right'}}
                </mat-icon>
            </button>
            <table class="full-width" >
                <tr class="custom-table-row" formGroupName="laborCostsHeader">
                    <td class="estimate-table-column width-190">{{ 'LABOR_COSTS' | translate}}</td>
                    <td class="estimate-table-column width-110">
                        {{ laborCostsFormGroup.get('laborCostsHeader.cost').value | multilingualCurrency }}
                    </td>
                    <td class="estimate-table-column width-70"></td>
                    <td class="estimate-table-column width-70">
                        {{ laborCostsFormGroup.get('laborCostsHeader.tdcPercentage')?.value | decimalPrecision }}%
                    </td>
                    <td class="estimate-table-column width-70">
                        <ng-container *ngIf=" isMarkUpSelected; else laborCostsGrossMarginPercentage">
                            {{ laborCostsFormGroup.get('laborCostsHeader.markUpPercentage')?.value | decimalPrecision }}%
                        </ng-container>
                        <ng-template #laborCostsGrossMarginPercentage>
                            {{ laborCostsFormGroup.get('laborCostsHeader.grossMarginPercentage')?.value | decimalPrecision }}%
                        </ng-template>
                    </td>
                    <td class="estimate-table-column width-210 padding-gm">
                        {{ laborCostsFormGroup.get('laborCostsHeader.grossMargin')?.value | multilingualCurrency }}
                    </td>
                    <td class="estimate-table-column width-110">
                        {{ laborCostsFormGroup.get('laborCostsHeader.sellPrice')?.value | multilingualCurrency }}
                    </td>
                </tr>
            </table>
        </div>

        <div *ngIf="isLaborCostsExpanded" >
            <app-sol-estimate-table-labor-cost-row
                [isMarkUpSelected]="isMarkUpSelected"
                [sellAsPricingMode]="sellAsPricingMode"
                [laborCostRowForm]="getLaborCostRowForm('projectManagement')"
                [rowLabel]="'PROJECT_MANAGEMENT'"
            ></app-sol-estimate-table-labor-cost-row>

            <app-sol-estimate-table-labor-cost-row
                [isMarkUpSelected]="isMarkUpSelected"
                [sellAsPricingMode]="sellAsPricingMode"
                [laborCostRowForm]="getLaborCostRowForm('engineering')"
                [rowLabel]="'ENGINEERING'"
            ></app-sol-estimate-table-labor-cost-row>

            <app-sol-estimate-table-labor-cost-row
                [isMarkUpSelected]="isMarkUpSelected"
                [sellAsPricingMode]="sellAsPricingMode"
                [laborCostRowForm]="getLaborCostRowForm('cyberSecurityEngineering')"
                [rowLabel]="'CYBER_SECURITY_ENGINEERING'"
            ></app-sol-estimate-table-labor-cost-row>

            <app-sol-estimate-table-labor-cost-row
                [isMarkUpSelected]="isMarkUpSelected"
                [sellAsPricingMode]="sellAsPricingMode"
                [laborCostRowForm]="getLaborCostRowForm('energyEngineering')"
                [rowLabel]="'ENERGY_ENGINEERING'"
            ></app-sol-estimate-table-labor-cost-row>

            <app-sol-estimate-table-labor-cost-row
                [isMarkUpSelected]="isMarkUpSelected"
                [sellAsPricingMode]="sellAsPricingMode"
                [laborCostRowForm]="getLaborCostRowForm('electricalEngineering')"
                [rowLabel]="'ELECTRICAL_ENGINEERING'"
            ></app-sol-estimate-table-labor-cost-row>
          
            <app-sol-estimate-table-labor-cost-row
                [isMarkUpSelected]="isMarkUpSelected"
                [sellAsPricingMode]="sellAsPricingMode"
                [laborCostRowForm]="getLaborCostRowForm('networkEngineering')"
                [rowLabel]="'NETWORK_ENGINEERING'"
            ></app-sol-estimate-table-labor-cost-row>

            <app-sol-estimate-table-labor-cost-row
                [isMarkUpSelected]="isMarkUpSelected"
                [sellAsPricingMode]="sellAsPricingMode"
                [laborCostRowForm]="getLaborCostRowForm('qualificationEngineering')"
                [rowLabel]="'QUALIFICATION_ENGINEERING'"
            ></app-sol-estimate-table-labor-cost-row>

            <app-sol-estimate-table-labor-cost-row
                [isMarkUpSelected]="isMarkUpSelected"
                [sellAsPricingMode]="sellAsPricingMode"
                [laborCostRowForm]="getLaborCostRowForm('graphics')"
                [rowLabel]="'GRAPHICS'"
            ></app-sol-estimate-table-labor-cost-row>
        
            <app-sol-estimate-table-labor-cost-row
                [isMarkUpSelected]="isMarkUpSelected"
                [sellAsPricingMode]="sellAsPricingMode"
                [laborCostRowForm]="getLaborCostRowForm('programming')"
                [rowLabel]="'PROGRAMMING'"
            ></app-sol-estimate-table-labor-cost-row>
        
            <app-sol-estimate-table-labor-cost-row
                [isMarkUpSelected]="isMarkUpSelected"
                [sellAsPricingMode]="sellAsPricingMode"
                [laborCostRowForm]="getLaborCostRowForm('specialist')"
                [rowLabel]="'SPECIALIST'"
            ></app-sol-estimate-table-labor-cost-row>
        
            <app-sol-estimate-table-labor-cost-row
                [isMarkUpSelected]="isMarkUpSelected"
                [sellAsPricingMode]="sellAsPricingMode"
                [laborCostRowForm]="getLaborCostRowForm('digitalDeploymentSpecialist')"
                [rowLabel]="'DIGITAL_DEPLOYMENT_SPECIALIST'"
            ></app-sol-estimate-table-labor-cost-row>

            <app-sol-estimate-table-labor-cost-row
                [isMarkUpSelected]="isMarkUpSelected"
                [sellAsPricingMode]="sellAsPricingMode"
                [laborCostRowForm]="getLaborCostRowForm('mechanical')"
                [rowLabel]="'MECHANICAL'"
            ></app-sol-estimate-table-labor-cost-row>

            <app-sol-estimate-table-labor-cost-row
                [isMarkUpSelected]="isMarkUpSelected"
                [sellAsPricingMode]="sellAsPricingMode"
                [laborCostRowForm]="getLaborCostRowForm('electrical')"
                [rowLabel]="'ELECTRICAL'"
            ></app-sol-estimate-table-labor-cost-row>

                
        </div>
    </div>